"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogGroupName = exports.RETENTION_IN_DAYS = exports.SENSITIVE_PRINT_LOG_GROUP_NAME_PREFIX = void 0;
/**
 * This prefix should be used for all sensitive data.
 * Account-level permission policy should be set to allow access to log groups with this prefix only to the Support team.
 */
exports.SENSITIVE_PRINT_LOG_GROUP_NAME_PREFIX = "support-sensitive-data-";
exports.RETENTION_IN_DAYS = 14;
const getLogGroupName = (programId) => `${exports.SENSITIVE_PRINT_LOG_GROUP_NAME_PREFIX}${programId}`;
exports.getLogGroupName = getLogGroupName;
//# sourceMappingURL=sensitivePrintUtils.js.map